import siteconfig from '../../assets/data/siteconfig'
import {
    TITLE_MUTATION,
    TITLE_ACTION_GET_TITLE
} from './title-types'

export default {
    namespaced: true,

    state: {
        title: {}
    },

    mutations: {
        [TITLE_MUTATION] (state, payload) {
            state.title = payload
        }
    },

    actions: {
        [TITLE_ACTION_GET_TITLE] ({commit, rootState}) {
            var titleObj = siteconfig.homeConfig.filter((obj) => {
                return rootState.route.path.includes(obj.path)
            })
            if (titleObj.length > 1) { commit(TITLE_MUTATION, titleObj[1]) } else { commit(TITLE_MUTATION, titleObj[0]) }
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/title.js